// extracted by mini-css-extract-plugin
export default {"base":"DashboardHeader_base__Co53A","titlePanel":"DashboardHeader_titlePanel__eilpc"};